import { createContext, useContext } from "react";
import { TTableBuilderSelection } from "./TableBuilder";
import { TTableBuilderDragLayerContext } from "./hooks/useTableBuilderDragLayerContext";
import { IWebsiteBuilderSectionEntityViewBoundingBox } from "../designSpace/views/hooks/sectionEntity/helpers/sectionEntityViewBoundingBox";
import { IWebsiteBuilderTable } from "../nodes/container/websiteBuilderTable";
import { TTableBuilderDomNodeRefMap } from "./hooks/useTableBuilderDomNodeRefMapRegistration";
import { ITableBuilderOperations } from "./hooks/useTableBuilderOperations";

interface ITableBuilderContext {
  selection: TTableBuilderSelection;
  hoveredRowId: string;
  hoveredColumnIndex: number;
  dragLayerContext: TTableBuilderDragLayerContext;
  containerBoundingBox: IWebsiteBuilderSectionEntityViewBoundingBox;
  containerBuilderUIPortalId: string;
  domNodeRefMap: TTableBuilderDomNodeRefMap;
  operations: ITableBuilderOperations;
  tableNode: IWebsiteBuilderTable;
  tableRef: React.MutableRefObject<HTMLTableElement>;
  keyboardCommandsDisabledRef: React.MutableRefObject<boolean>;
}

const defaultTableBuilderContext: ITableBuilderContext = {
  selection: null,
  hoveredRowId: null,
  hoveredColumnIndex: null,
  dragLayerContext: null,
  containerBoundingBox: null,
  containerBuilderUIPortalId: null,
  domNodeRefMap: null,
  operations: null,
  tableNode: null,
  tableRef: null,
  keyboardCommandsDisabledRef: null,
};

export const TableBuilderContext = createContext<ITableBuilderContext>(defaultTableBuilderContext);
export const useTableBuilderContext = () => useContext(TableBuilderContext);